var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShadow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h46v46H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#CDE1E8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.464 25.499 17.037 17.037A19.663 19.663 0 0 1 3.464 25.499m.913-8.94 18.62 18.62v5.208L3.415 20.805c.161-1.471.496-2.887.962-4.246m3.57-6.29 15.05 15.056v5.21L5.81 13.341a19.536 19.536 0 0 1 2.136-3.073m5.395-4.458 9.655 9.655v5.209L10.269 7.947c.95-.807 1.98-1.521 3.073-2.136m9.655-2.527v7.538l-6.438-6.439a19.58 19.58 0 0 1 6.438-1.099m0-3.284C10.319 0 0 10.319 0 23.003 0 35.681 10.319 46 22.997 46 35.68 46 46 35.681 46 23.003 46 10.32 35.681 0 22.997 0",
    mask: "url(#b)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShadow);
export default __webpack_public_path__ + "static/media/icon_shadow.ede5968da872f8c549c19b538c5ab5f5.svg";
export { ForwardRef as ReactComponent };